import config from '../../server/config'

export class APIException {
  constructor(errors) {
    this._errors = errors
  }
  get errors() {
    return this._errors
  }
}

const processFetch = (response) => {
  if (!response) return {}
  if (response.status === 'Ok') {
    return response
  }

  throw new APIException(response.errors ? response.errors : [response])
}

const request = async ({
  method,
  contentType,
  fetch,
  endpoint,
  getState,
  body,
}) => {
  let response = null

  const options = {
    method,
    headers: {
      pragma: 'no-cache',
      'cache-control': 'no-cache',
    },
  }

  const viewer = getState().users.viewer

  if (contentType) options.headers['Content-Type'] = contentType
  if (viewer) options.headers['x-access-token'] = viewer.tokens.access
  if (body) options.body = body

  try {
    response = await fetch(`${config.apiUrl || ''}/api/v1/${endpoint}`, options)
    const responseBody = processFetch(response)

    return responseBody
  } catch (e) {
    response = {}
    response.errors = e.errors
    console.log(e) // eslint-disable-line
    throw response
  }
}

const createGetQuery = (endpoint, query) => {
  if (!query) return endpoint
  const { filters, fields, ...rest } = query
  endpoint += '?'
  if (filters && Object.keys(filters).length) endpoint += `filter=${JSON.stringify(filters)}&`
  if (fields) endpoint += `fields=${JSON.stringify(fields)}&`
  if (rest) {
    Object.keys(rest).forEach(key => {
      endpoint += `${key}=${rest[key]}&`
    })
  }
  return endpoint.slice(0, -1)
}

export const apiGet = async ({ fetch, endpoint, getState, query }) => {
  endpoint = createGetQuery(endpoint, query)
  try {
    const body = await request({
      fetch,
      endpoint,
      getState,
      method: 'GET',
      contentType: 'application/json',
    })
    return body
  } catch (e) {
    throw e
  }
}

export const apiPost = async ({ fetch, endpoint, getState, body }) => {
  try {
    const responseBody = await request({
      fetch,
      endpoint,
      getState,
      method: 'POST',
      contentType: 'application/json',
      body: JSON.stringify(body),
    })
    return responseBody
  } catch (e) {
    throw e
  }
}

export const apiPostFile = async ({ fetch, endpoint, getState, body }) => {
  try {
    const formData = new FormData()
    const keys = Object.keys(body)
    keys.forEach((key) => {
      if (body[key]) {
        formData.append(key, Array.isArray(body[key]) ? JSON.stringify(body[key]) : body[key])
      }
    })

    const responseBody = await request({
      fetch,
      endpoint,
      getState,
      method: 'POST',
      body: formData,
    })
    return responseBody
  } catch (e) {
    throw e
  }
}

export const apiPutFile = async ({ fetch, endpoint, getState, body }) => {
  try {
    const formData = new FormData()
    const keys = Object.keys(body)
    keys.forEach((key) => {
      if (body[key]) {
        formData.append(key, Array.isArray(body[key]) ? JSON.stringify(body[key]) : body[key])
      }
    })

    const responseBody = await request({
      fetch,
      endpoint,
      getState,
      method: 'PUT',
      body: formData,
    })
    return responseBody
  } catch (e) {
    throw e
  }
}

export const apiPut = async ({ fetch, endpoint, getState, body }) => {
  try {
    const responseBody = await request({
      fetch,
      endpoint,
      getState,
      method: 'PUT',
      contentType: 'application/json',
      body: JSON.stringify(body),
    })
    return responseBody
  } catch (e) {
    throw e
  }
}

export const apiPatch = async ({ fetch, endpoint, getState, body }) => {
  try {
    const responseBody = await request({
      fetch,
      endpoint,
      getState,
      method: 'PATCH',
      contentType: 'application/json',
      body: JSON.stringify(body),
    })
    return responseBody
  } catch (e) {
    throw e
  }
}

export const apiDelete = async ({ fetch, endpoint, getState, query }) => {
  endpoint = createGetQuery(endpoint, query)
  try {
    const body = await request({
      fetch,
      endpoint,
      getState,
      method: 'DELETE',
      contentType: 'application/json',
    })
    return body
  } catch (e) {
    throw e
  }
}



// WEBPACK FOOTER //
// ./src/common/lib/api.js